export default __webpack_public_path__ + "static/media/error.d05e4084.jpeg";